/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0xe4d145 from'./descriptor.js';class Message extends _0xe4d145{constructor(..._0x4f32d9){super();}static['fromJSON'](_0x34c939){throw new TypeError('Must\x20be\x20implemented\x20in\x20a\x20child\x20class!');}}Message['TYPE']='1000';export default Message;